<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <el-breadcrumb
            separator-class="el-icon-arrow-right"
            class="mainBread"
          >
            <el-breadcrumb-item>{{ $t("menu.Home_View") }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{
              $t("menu.RoutineMaintenance_View")
            }}</el-breadcrumb-item>
          </el-breadcrumb>

          <el-form
            ref="formselect"
            :model="formselect"
            class="queryform_div"
            label-width="102px"
          >
            <el-row :gutter="24">
              <el-col :md="8" :xs="24" :sm="12">
                <el-form-item :label="$t('acronym.airCompressorSN')">
                  <el-input
                    type="text"
                    placeholder=" "
                    v-model="formselect.dsn"
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <!-- <el-col :md="8" :xs="24" :sm="24">
                <el-form-item
                  :label="$t('title.province') + ' ' + $t('title.city')"
                >
                  <template>
                    <el-cascader
                      v-model="formselect.cityList"
                      :options="optionTotalCity"
                      style="width: 100%"
                      collapse-tags
                      placeholder=""
                      size="small"
                      :props="{ multiple: true, checkStrictly: true }"
                    ></el-cascader>
                  </template>
                </el-form-item>
              </el-col> -->
              <!-- <el-col :md="8" :xs="24" :sm="12">
                <el-form-item :label="$t('acronym.gatewaySN')">
                  <el-input
                    type="text"
                    placeholder=" "
                    v-model="formselect.gsn"
                    size="small"
                  />
                </el-form-item>
              </el-col> -->
              <!-- <el-col :md="8" :xs="24" :sm="12">
                <el-form-item :label="$t('acronym.gatewayBindingStatus')">
                  <el-select
                    size="small"
                    v-model="formselect.gatewayState"
                    :placeholder="$t('desc.select')"
                  >
                    <el-option value="全部" :label="$t('desc.all')"></el-option>
                    <el-option :label="$t('title.Bound')" value="1"></el-option>
                    <el-option
                      :label="$t('title.Unbound')"
                      value="0"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="8" :xs="24" :sm="12">
                <el-form-item :label="$t('acronym.ccn')">
                  <el-input
                    type="text"
                    placeholder=" "
                    v-model="formselect.ccn"
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :md="8" :xs="24" :sm="12">
                <el-form-item :label="$t('desc.customer')">
                  <el-input
                    type="text"
                    placeholder=" "
                    v-model="formselect.custName"
                    size="small"
                  />
                </el-form-item>
              </el-col> -->
              <el-col :md="8" :xs="24" :sm="12">
                <el-form-item :label="$t('acronym.serviceType')">
                  <el-select
                    size="small"
                    v-model="formselect.serviceType"
                    :placeholder="$t('desc.select')"
                  >
                    <el-option
                      value="99"
                      :label="$t('desc.select')"
                    ></el-option>
                    <el-option
                      :label="$t('desc.routineMaintenance2000')"
                      value="2000"
                    ></el-option>
                    <el-option
                      :label="$t('desc.routineMaintenance4000')"
                      value="4000"
                    ></el-option>
                    <el-option
                      :label="$t('desc.routineMaintenance8000')"
                      value="8000"
                    ></el-option>
                    <el-option
                      :label="$t('desc.routineMaintenance16000')"
                      value="16000"
                    ></el-option>
                    <el-option
                      :label="$t('desc.routineMaintenance16000More')"
                      value="18000"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="8" :xs="24" :sm="12">
                <el-form-item :label="$t('acronym.serviceStatus')">
                  <el-select
                    size="small"
                    v-model="formselect.maintainType"
                    :placeholder="$t('desc.select')"
                  >
                    <el-option
                      :label="$t('desc.select')"
                      value="99"
                    ></el-option>
                    <el-option
                      :label="$t('desc.maintained')"
                      value="1"
                    ></el-option>
                    <el-option
                      :label="$t('desc.notMaintained')"
                      value="0"
                    ></el-option>
                    <el-option
                      :label="$t('desc.expireMaintain')"
                      value="2"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="24" :xs="24" :sm="24" >
                <el-form-item>
                  <el-button
                    type="primary"
                    @click="getPreMaintainList('search')"
                    size="small"
                    >{{ $t("button.query") }}</el-button
                  >
                  <el-button @click="resetKeyword" size="small">{{
                    $t("button.reset")
                  }}</el-button>
                  <el-button
                     icon="el-icon-download"
                    size="small"
                    style="float: right"
                    @click="exportDeviceList()"
                    v-if="hasExportAuth"
                    :loading="loading"
                    >{{ $t("button.exportAll") }}</el-button
                  >
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <template>
            <div class="tableDiv">
              <el-table
                :data="tableData1"
                stripe
                style="width: 100%"
                :empty-text="$t('desc.noData')"
              >
                <el-table-column
                  type="index"
                  :label="$t('title.serialNumber')"
                  width="60"
                  fixed="left"
                >
                </el-table-column>
                <el-table-column
                  prop="dsn"
                  :label="$t('desc.airCompressorSN')"
                  min-width="150px"
                  fixed="left"
                >
                </el-table-column>
                <el-table-column
                  prop="maintainType"
                  :label="$t('title.maintainTypeDesc')"
                  min-width="160px"
                >
                </el-table-column>
                <!-- <el-table-column
                prop="gatewayState"
                :label="$t('title.isBinding')"
                min-width="150px"
              >
              </el-table-column> -->
                <el-table-column
                  prop="maintainTypeStr"
                  :label="$t('title.serviceStatus')"
                  min-width="150px"
                >
                </el-table-column>
                <el-table-column
                  prop="modelId"
                  :label="$t('title.airCompressorType')"
                  min-width="250px"
                >
                </el-table-column> 
                <el-table-column
                  prop="customerName"
                  :label="$t('desc.customer')"
                  min-width="300px"
                >
                </el-table-column>
                <!-- <el-table-column
                  prop="customerCenter"
                  :label="$t('title.customerCenter')"
                  min-width="300px"
                >
                </el-table-column> -->
                <!-- <el-table-column
                prop="ccn"
                :label="$t('title.controlsCCN')"
                width="200"
              >
              </el-table-column>
              <el-table-column
                prop="gsn"
                :label="$t('desc.gatewaySN')"
                min-width="150px"
              >
              </el-table-column>
              <el-table-column
                prop="runningTime"
                :label="$t('title.runningTime')"
                min-width="160px"
              >
              </el-table-column> -->
                
                <el-table-column
                  :label="$t('title.operate')"
                  min-width="85px"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <el-button
                      icon="el-icon-document"
                      type="default"
                      circle
                      size="mini"
                      :title="$t('title.serviceHistory')"
                      @click="showHistoryDialog(scope.row)"
                    ></el-button>
                    <template>
                      <el-popconfirm
                        :confirm-button-text="$t('button.confirm')"
                        :cancel-button-text="$t('button.cancel')"
                        icon="el-icon-info"
                        icon-color="red"
                        :title="$t('button.dprm')"
                        @confirm="pushMaintainMsg(scope.row)"
                      >
                        <el-button
                          icon="fa fa-wrench"
                          type="primary"
                          circle
                          size="mini"
                          slot="reference"
                          :title="$t('title.pushCycleMaintain')"
                          v-if="hasMaintainPush"
                        ></el-button>
                      </el-popconfirm>
                    </template>
                    <el-button
                      icon="el-icon-check"
                      type="success"
                      circle
                      size="mini"
                      :title="$t('title.alreadyMaintained')"
                      @click="openServiceDialog(scope.row)"
                      v-if="hasMaintainConfirm"
                    ></el-button>
                    <!-- <template>
                    <el-popconfirm
                      :confirm-button-text="$t('button.confirm')"
                      :cancel-button-text="$t('button.cancel')"
                      icon="el-icon-info"
                      icon-color="red"
                      :title="$t('button.dsl')"
                      v-if="scope.row.isShowLoseBtn"
                      @confirm="addMaintainLose(scope.row)"
                    >
                      <el-button
                        icon="el-icon-close"
                        type="danger"
                        circle
                        size="mini"
                        slot="reference"
                        :title="$t('title.maintainLose')"
                      ></el-button>
                    </el-popconfirm>
                  </template> -->
                    <el-button
                      icon="el-icon-download"
                      type="default"
                      circle
                      size="mini"
                      :title="$t('button.exportDetail')"
                      style="font-weight: bold"
                      @click="exprtMaintain(scope.row)"
                      v-if="hasExportAuth"
                    ></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                :page-size="pagination.pageSize"
                :page-sizes="[10, 20, 50]"
                :current-page.sync="pagination.current"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                layout="prev, pager, next,sizes"
                :total="pagination.totalPage"
                style="text-align: center; margin-top: 10px"
              >
              </el-pagination>
            </div>
          </template>
        </el-main>
      </el-scrollbar>
    </el-container>
    <el-dialog
      title="推送例行保养"
      :visible.sync="showPushDialog"
      width="80%"
      top="5vh"
      :before-close="closePushDialog"
    >
      <el-form ref="pushform" :model="pushform" label-width="120px">
        <el-row :gutter="24">
          <el-col :xs="24">
            <el-form-item label="空压机SN号">
              <el-input
                :value="dialogDsn"
                :disabled="true"
                style="width: 200px"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item label="定期保养检查清单">
              <template>
                <div class="tableDiv">
                  <el-table
                    :data="tableMaintain"
                    stripe
                    class="formSTable"
                    :height="TableH"
                    :empty-text="$t('desc.noData')"
                  >
                    <el-table-column :label="deviceTypeName">
                      <el-table-column
                        prop="workRang"
                        label="工作范围"
                        min-width="240px"
                      >
                      </el-table-column>
                    </el-table-column>
                    <el-table-column label="保养计划">
                      <el-table-column label="2000小时" min-width="150px">
                        <template slot-scope="scope">
                          <el-checkbox
                            v-for="opt in scope.row.h2000"
                            :key="opt.code"
                            :label="opt.code"
                            v-model="pushform.checkListPush"
                          >
                            {{ opt.label }}
                          </el-checkbox>
                        </template>
                      </el-table-column>
                      <el-table-column label="4000小时" min-width="150px">
                        <template slot-scope="scope">
                          <el-checkbox
                            v-for="opt in scope.row.h4000"
                            :key="opt.code"
                            :label="opt.code"
                            v-model="pushform.checkListPush"
                          >
                            {{ opt.label }}
                          </el-checkbox>
                        </template>
                      </el-table-column>
                      <el-table-column label="8000小时" min-width="150px">
                        <template slot-scope="scope">
                          <el-checkbox
                            v-for="opt in scope.row.h8000"
                            :key="opt.code"
                            :label="opt.code"
                            v-model="pushform.checkListPush"
                          >
                            {{ opt.label }}
                          </el-checkbox>
                        </template>
                      </el-table-column>
                      <el-table-column label="16000小时" min-width="150px">
                        <template slot-scope="scope">
                          <el-checkbox
                            v-for="opt in scope.row.h16000"
                            :key="opt.code"
                            :label="opt.code"
                            v-model="pushform.checkListPush"
                          >
                            {{ opt.label }}
                          </el-checkbox>
                        </template>
                      </el-table-column>
                    </el-table-column>
                  </el-table>
                </div>
              </template>
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item>
              <el-button @click="pushSubmit" type="success">{{
                $t("button.confirm")
              }}</el-button>
              <el-button @click="closePushDialog">{{
                $t("button.cancel")
              }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog
      :title="$t('title.serviceConfirmed')"
      :visible.sync="showServiceDialog"
      width="80%"
      top="5vh"
      :before-close="closeDialog"
    >
      <el-form ref="serviceform" :model="serviceform" label-width="180px">
        <el-row :gutter="24">
          <el-col :sm="12" :xs="24">
            <el-form-item :label="$t('desc.dsn')">
              <el-input
                :value="dialogDsn"
                :disabled="true"
                style="width: 200px"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item :label="$t('desc.ServiceOrderCode')">
              <el-input
                v-model="serviceform.serviceOrderCode"
                style="width: 200px"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item :label="$t('desc.pmc')">
              <template>
                <div class="tableDiv">
                  <el-table
                    :data="tableService"
                    ref="tableService"
                    stripe
                    class="formSTable"
                    :height="TableH"
                    :empty-text="$t('desc.noData')"
                  >
                    <el-table-column
                      prop="workRang"
                      :label="$t('desc.workExtent')"
                      min-width="200px"
                    >
                      <template slot-scope="scope">
                        <template v-if="scope.row.show">
                          <el-button
                            type="danger"
                            icon="el-icon-delete"
                            size="mini"
                            circle
                            @click="delServiceRow(scope.$index, scope.row)"
                          ></el-button>
                          <el-input
                            v-model="scope.row.workRang"
                            size="mini"
                            style="width: 85%; margin-left: 10px"
                          ></el-input>
                        </template>
                        <template v-else>
                          <span>{{ scope.row.workRang }}</span>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column
                      :label="$t('desc.serviceComparison')"
                      min-width="150px"
                    >
                      <template slot-scope="scope">
                        <template v-if="scope.row.show">
                          <!-- <el-checkbox
                          v-for="opt in allselect"
                          :key="opt.code"
                          :label="opt.code"
                           v-model="serviceform.checkList"
                        >
                          {{ opt.label }}
                        </el-checkbox> -->
                        </template>
                        <template v-else>
                          <el-checkbox
                            v-for="opt in scope.row.h4000"
                            :key="opt.code"
                            :label="opt.code"
                            disabled
                            checked
                          >
                            {{ opt.label }}
                          </el-checkbox>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column
                      :label="$t('desc.serviceDetails')"
                      min-width="150px"
                    >
                      <template slot-scope="scope">
                        <template v-if="scope.row.show">
                          <el-checkbox
                            v-for="opt in allselect"
                            :key="getOptionKey(scope.row.workRang, opt.code)"
                            :label="getOptionKey(scope.row.workRang, opt.code)"
                            v-model="serviceform.checkList"
                          >
                            {{ opt.label }}
                          </el-checkbox>
                        </template>
                        <template v-else>
                          <el-checkbox
                            v-for="opt in scope.row.h2000"
                            :key="getOptionKey(scope.row.workRang, opt.code)"
                            :label="getOptionKey(scope.row.workRang, opt.code)"
                            v-model="serviceform.checkList"
                          >
                            {{ opt.label }}
                          </el-checkbox>
                        </template>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <el-button
                  class="el-icon-plus"
                  size="small"
                  @click.prevent="addServiceRow()"
                ></el-button>
              </template>
            </el-form-item>
          </el-col>

          <el-col :xs="24">
            <el-form-item>
              <el-button @click="submit" type="success">{{
                $t("button.confirm")
              }}</el-button>
              <el-button @click="closeDialog">{{
                $t("button.cancel")
              }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="$t('title.maintainTab')"
      :visible.sync="dialogServiceHistory"
      :before-close="closeHistory"
      width="60%"
      top="5vh"
    >
      <!-- <el-button
      type="default"
      style="margin-bottom: 10px"
      @click="exportDetail()"
      :loading="detailLoading"
      >{{ $t("button.export") }}</el-button
    > -->
      <div class="tableDiv">
        <el-table
          :data="maintainList"
          stripe
          style="width: 100%"
          class="alarmTable"
          height="432px"
        >
          <el-table-column
            type="index"
            :label="$t('title.serialNumber')"
            width="60"
          >
          </el-table-column>
          <el-table-column
            prop="maintainRangeStr"
            :label="$t('title.maintainTypeDesc')"
            min-width="200px"
          >
          </el-table-column>
          <el-table-column
            prop="maintainTypeStr"
            :label="$t('title.serviceStatus')"
            min-width="150px"
          >
          </el-table-column>
          <el-table-column :label="$t('title.operate')" width="120">
            <template slot-scope="scope">
              <el-button
                icon="el-icon-document"
                type="default"
                circle
                size="mini"
                :title="$t('desc.serviceDetails')"
                v-if="scope.row.maintainType == 1"
                @click="openMaintainDialog(true, scope.row)"
              ></el-button>
              <el-button
                icon="el-icon-download"
                type="default"
                circle
                size="mini"
                :title="$t('button.exportDetail')"
                style="font-weight: bold"
                @click="exprtMaintain(scope.row)"
                v-if="hasExportAuth"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <monitor-maintain-dialog
      :dialogClient="dialogMaintain"
      :title="maintainTitle"
      :serviceform="serviceDetailform"
      :tableService="tableDetail"
      @dialogVisibleEvent="openMaintainDialog"
    >
    </monitor-maintain-dialog>
  </div>
</template>
<script>
import {
  getPreMaintainListForWeb,
  getMaintainItemTable,
  updateMaintainHistorys,
  getMaintainHistoryByDeviceId,
  updateMaintainHistoryPushs,
  getMaintainItemConfirmTable,
  addMaintainLose,
  exportExcel,
  exportExcelNew,
  getMaintainExportData,
  pushMaintainMsg,
  authOperationCheck,
  getMaintainRecord,
  getRegionTree,
} from "../../api/api";
import deviceDialogComponent from "../../components/content/maintabber/CompressorDialog";
import gatewayRegisterComponent from "../../components/content/maintabber/GatewayRegisterDialog";
import monitorDeviceInfoDialog from "../../components/content/monitor/MonitorDeviceInfoDialog";
import monitorCcnTable from "../../components/content/monitor/MonitorCcnTable";
import monitorMaintainDialog from "../../components/content/monitor/MonitorMaintainDialog";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "index",
  components: {
    "device-dialog": deviceDialogComponent,
    "gateway-dialog": gatewayRegisterComponent,
    "monitor-deviceInfo-Dialog": monitorDeviceInfoDialog,
    "monitor-ccn-table": monitorCcnTable,
    "monitor-maintain-dialog": monitorMaintainDialog,
  },
  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
      navselected: (state) => state.adminleftnavnum,
    }),
  },
  data() {
    return {
      isIndeterminate: true,
      gsnStateList: {
        0: "未连接",
        1: "正常",
        2: "警告",
        "-1": "脱机",
      },
      bondStatusTraslate: {
        已绑定: "title.Bound",
        未绑定: "title.Unbound",
      },
      refForm: "",
      dialogTitle: "",
      DsnList: [],
      gsnList: [],
      ActiveTab: "first",

      formselect: {},
      tableData1: [],
      custOption: [],
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      TableH: "",
      showPushDialog: false,
      showServiceDialog: false,
      pushform: {
        checkListPush: [],
      },
      serviceform: {
        checkList: [],
      },
      tableMaintain: [],
      tableService: [],
      allselect: [
        { code: "检查", label: "检查" },
        { code: "清洁", label: "清洁" },
        { code: "更换", label: "更换" },
        { code: "调整", label: "调整" },
        { code: "添加", label: "添加" },
        { code: "必要时更换", label: "必要时更换" },
        { code: "记录", label: "记录" },
        { code: "取样检验", label: "取样检验" },
      ],
      WorkForm: "",
      checkList: [],
      translateList: {
        定期保养: "desc.pmPureLabor",
        一次性保养: "desc.oneTimePM",
        延长保修: "desc.extendWarranty",
        工厂保内: "desc.factoryWarranty",
        其他: "desc.other",
      },
      labelName: "",
      dialogDsn: "",
      dialogDeviceId: "",
      deviceTypeName: "",
      runningTime: "",
      hasExportAuth: false,
      hasMaintainPush: false,
      hasMaintainConfirm: false,
      loading: false,
      detailLoading: false,
      //服务历史
      dialogServiceHistory: false,
      maintainList: [],
      optionTotalCity: [],
      detailDsn: "",
      dialogMaintain: false,
      maintainTitle: "",
      serviceDetailform: {},
      tableDetail: [],
      deviceInfo: {},
    };
  },
  created: function () {
    this.SetMapHeight();
    window.addEventListener("resize", this.SetMapHeight);

    this.authOperation("RoutineMaintenance");
  },
  async mounted() {
    if (this.$route.params.maintainType) {
      this.$set(
        this.formselect,
        "maintainType",
        this.$route.params.maintainType
      );
    }
    this.getRegionTree();
    this.getPreMaintainList();
  },
  methods: {
    authOperation(curPage) {
      var that = this;
      var res = authOperationCheck(curPage);
      that.hasExportAuth = res.hasExportAuth;
      that.hasMaintainPush = res.hasMaintainPush;
      that.hasMaintainConfirm = res.hasMaintainConfirm;
    },
    getOptionKey(a, b) {
      return a + "-" + b;
    },
    getRegionTree() {
      let that = this;
      getRegionTree().then((res) => {
        let data = res.result;
        that.optionTotalCity = data;
      });
    },
    getPreMaintainList(type = "normal") {
      let that = this;
      if (type == "search") {
        this.pagination.current = 1;
      }
      let skipcount = (this.pagination.current - 1) * this.pagination.pageSize;
      let postData = {
        Dsn: this.formselect.dsn,
        Gsn: this.formselect.gsn,
        GatewayState: this.formselect.gatewayState,
        Ccn: this.formselect.ccn,
        CustName: this.formselect.custName,
        ServiceType: this.formselect.serviceType,
        MaintainType: this.formselect.maintainType,
        CityList: this.formselect.cityList,
        Language: this.activeLang,
        SkipCount: skipcount,
        MaxResultCount: this.pagination.pageSize,
      };
      getPreMaintainListForWeb(postData)
        .then((res) => {
          console.log(res);
          let data = res.result.items;
          this.pagination.totalPage = res.result.totalCount;
          data.forEach((o) => {
            var runingTime = o.runningTime;
            var runningTimeInt = parseInt(runingTime);
            var mainTimeRange = o.maintainTime;
            // if (o.maintainType == 1) {
            //   o.isShowLoseBtn = false;
            // } else {
            //   if (
            //     (runningTimeInt > 1800 && runningTimeInt < 2500) ||
            //     (runningTimeInt > 3800 && runningTimeInt < 4500) ||
            //     (runningTimeInt > 7800 && runningTimeInt < 8500) ||
            //     (runningTimeInt > 15800 && runningTimeInt < 16500)
            //   ) {
            //     o.isShowLoseBtn = false;
            //   } else {
            //     if (o.LoseType == 1) {
            //       o.isShowLoseBtn = false;
            //     } else {
            //       o.isShowLoseBtn = true;
            //     }
            //   }
            // }

            if (o.maintainType == 1) {
              o.maintainTypeStr = that.$t("desc.maintained");
            } else {
              o.maintainTypeStr = that.$t("desc.notMaintained");
            }
            o.maintainType =
              mainTimeRange.toString() + that.$t("title.maintainType");
          });
          that.tableData1 = data;
          for (let index = 0; index < data.length; index++) {
            that.tableData1[index].gatewayState = that.$t(
              that.bondStatusTraslate[that.tableData1[index].gatewayState]
            );
          }
        })
        .catch((err) => {});
    },
    //这个方法没用上
    getMaintainItemTable(type) {
      let that = this;
      getMaintainItemTable(type).then((res) => {
        let data = res.result;
        that.tableMaintain = data;
        that.$nextTick(() => {
          this.getMaintainHistoryByDeviceId(that.dialogDeviceId);
        });
      });
    },
    getMaintainHistoryByDeviceId(deviceId, runningTime) {
      let that = this;
      getMaintainHistoryByDeviceId(deviceId, runningTime).then((res) => {
        let data = res.result;
        that.pushform = data;
        that.serviceform = data;
      });
    },
    getMaintainItemConfirmTable(type, runningTime, dsn) {
      let that = this;
      getMaintainItemConfirmTable(type, runningTime, dsn).then((res) => {
        let data = res.result;
        that.tableService = data;
        that.tableDetail = data;
        that.$nextTick(() => {
          this.getMaintainHistoryByDeviceId(that.dialogDeviceId, runningTime);
        });
      });
    },
    submit() {
      let that = this;
      if (!that.serviceform.serviceOrderCode) {
        that.$message({
          showClose: true,
          message: that.$t("tips.fillServiceNumber"),
          type: "error",
        });
        return false;
      }
      let postData = {
        CheckList: that.serviceform.checkList,
        Dsn: that.dialogDsn,
        DeviceId: that.dialogDeviceId,
        ServiceOrderCode: that.serviceform.serviceOrderCode,
        RunningTime: that.runningTime, //此处的runningTime其实是maintainTime
      };
      updateMaintainHistorys(postData).then((res) => {
        that.$message({
          showClose: true,
          message: this.$t("tips.saveSuccess"),
          type: "success",
        });
        that.showServiceDialog = false;
      });
    },
    //没用上
    pushSubmit() {
      let that = this;
      let postData = {
        CheckListPush: that.pushform.checkListPush,
        Dsn: that.dialogDsn,
        DeviceId: that.dialogDeviceId,
        ServiceOrderCode: that.pushform.serviceOrderCode,
        RunningTime: that.runningTime,
      };
      updateMaintainHistoryPushs(postData).then((res) => {
        that.$message({
          showClose: true,
          message: this.$t("tips.saveSuccess"),
          type: "success",
        });
        that.showPushDialog = false;
      });
    },

    //没用上
    addMaintainLose(row) {
      let that = this;
      let postData = {
        Dsn: row.dsn,
        DeviceId: row.id,
        MaintainHours: row.maintainTime,
        RunningTime: row.runningTime,
      };
      addMaintainLose(postData)
        .then((res) => {
          that.$message({
            showClose: true,
            message: this.$t("tips.oprationSuccess"),
            type: "success",
          });
        })
        .catch((err) => {
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },
    togleCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    resetKeyword() {
      this.formselect = {};
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getPreMaintainList();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getPreMaintainList();
    },
    SetMapHeight() {
      this.TableH = window.innerHeight * 0.8 - 190 + "px";
    },
    //这个方法也没用上
    openPushDialog(row) {
      this.showPushDialog = true;

      if (row.deviceType == 1) {
        this.deviceTypeName = "微油螺杆式空压机";
      } else {
        this.deviceTypeName = "无油螺杆式空压机";
      }
      this.dialogDsn = row.dsn;
      this.dialogDeviceId = row.id;
      this.runningTime = row.runningTime;
      this.labelName =
        row.maintainType.split(this.$t("title.maintainType"))[0] +
        this.$t("desc.hours");
      this.getMaintainItemTable(row.deviceType);
      this.$nextTick(() => {
        this.SetMapHeight();
      });
    },
    closePushDialog() {
      this.showPushDialog = false;
      this.pushform.checkListPush = [];
      this.dialogDsn = "";
      this.dialogDeviceId = "";
      this.runningTime = "";
      this.labelName = "";
      this.deviceTypeName = "";
    },
    openServiceDialog(row) {
      this.showServiceDialog = true;

      if (row.deviceType == 1) {
        this.deviceTypeName = "微油螺杆式空压机";
      } else {
        this.deviceTypeName = "无油螺杆式空压机";
      }
      this.dialogDsn = row.dsn;
      this.dialogDeviceId = row.id;
      this.runningTime = row.maintainTime;
      this.labelName = row.maintainTime + this.$t("desc.hours");
      if (!row.serviceOrderCode) {
        row.serviceOrderCode = "";
      }
      this.getMaintainItemConfirmTable(
        row.deviceType,
        row.maintainTime,
        row.dsn
      );

      this.$nextTick(() => {
        this.SetMapHeight();
      });
    },
    closeDialog() {
      this.showServiceDialog = false;
      this.serviceform = {};
      this.dialogDsn = "";
      this.dialogDeviceId = "";
      this.runningTime = "";
      this.labelName = "";
      this.deviceTypeName = "";
    },
    closeHistory() {
      this.dialogServiceHistory = false;
    },
    async showHistoryDialog(row) {
      this.dialogServiceHistory = true;
      this.detailDsn = row.dsn;
      this.deviceInfo = row;
      await this.getMaintainRecord(row.dsn);
    },
    async getMaintainRecord(dsn) {
      let that = this;
      let res = await getMaintainRecord(dsn);
      let data = res.result;
      that.maintainList = data;
      for (let index = 0; index < that.maintainList.length; index++) {
        const element = that.maintainList[index];
        that.maintainList[index].maintainRangeStr =
          that.maintainList[index].maintainRange +
          that.$t("title.maintainType");
        if (element.maintainType === 1) {
          that.maintainList[index].maintainTypeStr = that.$t(
            "title.alreadyMaintained"
          );
        } else {
          that.maintainList[index].maintainTypeStr =
            that.$t("title.maintainLose");
        }
      }
    },

    openMaintainDialog(visible, row) {
      let that = this;
      this.dialogMaintain = visible;
      if (visible) {
        this.serviceDetailform = row;
        this.maintainTitle = this.$t("title.serviceConfirmed");
        let type = 2;
        if (that.deviceInfo.deviceType == 1) {
          type = 1;
        }
        this.getMaintainItemConfirmTable(type, row.maintainRange, row.dsn);
        // this.$nextTick(() => {
        //   this.SetMapHeight();
        // });
      } else {
        // this.tableCCN = new Array();
      }
    },
    // 增加行
    addServiceRow() {
      let data = { show: true };
      this.tableService.push(data);
    },
    // 删除选中行
    delServiceRow(index, row) {
      this.tableService.splice(index, 1);
    },
    pushMaintainMsg(row) {
      let that = this;
      let postData = {
        dsn: row.dsn,
        deviceId: row.id,
      };
      pushMaintainMsg(postData)
        .then((res) => {
          that.$message({
            showClose: true,
            message: this.$t("tips.pushSuccess"),
            type: "success",
          });
        })
        .catch((err) => {
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },
    exprtMaintain(row) {
      let that = this;
      var headers = [
        { key: "dsn", title: "空压机SN号" },
        { key: "serviceOrderCode", title: "服务订单号" },
        { key: "maintainItemName", title: "工作范围" },
        { key: "subItemName", title: "服务项" },
      ];

      var fileName = "空压机" + row.dsn + "服务明细.xlsx";
      // var runningTimeInt = parseInt(row.maintainTime);
      // var mainTimeRange = runningTimeInt;
      // if (runningTimeInt > 1800 && runningTimeInt < 2500) mainTimeRange = 2000;
      // if (runningTimeInt > 3800 && runningTimeInt < 4500) mainTimeRange = 4000;
      // if (runningTimeInt > 7800 && runningTimeInt < 8500) mainTimeRange = 8000;
      // if (runningTimeInt > 15800 && runningTimeInt < 16500)
      //   mainTimeRange = 16000;
      if (!row.maintainTime) {
        row.maintainTime = Number.parseInt(row.maintainRange);
      }

      getMaintainExportData(row.dsn, row.maintainTime).then((res) => {
        if (res.result) {
          var data = res.result;
          //导入数据里有null会导致文件损坏
          const dataSource = data.map((item) => {
            Object.keys(item).forEach((key) => {
              // 后端传null node写入会有问题
              if (item[key] === null) {
                item[key] = "";
              }

              if (Array.isArray(item[key])) {
                item[key] = item[key].join(",");
              }
            });
            return item;
          });
          exportExcel(headers, dataSource, fileName);
        }
      });
    },
    exportDetail() {
      let that = this;
      that.detailLoading = true;
      var exportData = [["服务类型", "服务状态"]];
      var fileName = `空压机${that.detailDsn}维修保养记录.xlsx`;
      //导入数据里有null会导致文件损坏
      const dataSource = that.maintainList.map((item) => {
        Object.keys(item).forEach((key) => {
          // 后端传null node写入会有问题
          if (item[key] === null) {
            item[key] = "";
          }
          if (Array.isArray(item[key])) {
            item[key] = item[key].join(",");
          }
        });
        return item;
      });
      dataSource.forEach((item) => {
        let rowData = [];
        rowData = [item.maintainRangeStr, item.maintainTypeStr];
        exportData.push(rowData);
      });
      exportExcelNew(exportData, fileName);
      // exportExcel(headers, dataSource, fileName);
      that.detailLoading = false;
    },
    exportDeviceList() {
      let that = this;
      that.loading = true;
      var exportData = [
        [
          "空压机SN号",
          "空压机型号",
          "客户",
          "客户中心",
          "控制器软件CCN号",
          "网关SN号",
          "运行时间",
          "服务类型",
          "绑定状态",
          "服务状态",
        ],
      ];
      var fileName = "预测维护空压机列表导出.xlsx";
      let postData = {
        Dsn: this.formselect.dsn,
        Gsn: this.formselect.gsn,
        GatewayState: this.formselect.gatewayState,
        Ccn: this.formselect.ccn,
        CustName: this.formselect.custName,
        ServiceType: this.formselect.serviceType,
        MaintainType: this.formselect.maintainType,
        CityList: this.formselect.cityList,
        Language: this.activeLang,
        SkipCount: 0,
        MaxResultCount: 100000,
      };
      getPreMaintainListForWeb(postData).then((res) => {
        if (res.result) {
          let data = res.result.items;
          data.forEach((o) => {
            var mainTimeRange = o.maintainTime;
            o.maintainType =
              mainTimeRange.toString() + that.$t("title.maintainType");
            if (o.loseType == 1) {
              o.maintainTypeStr = that.$t("desc.lost");
            } else if (o.maintainType == 1) {
              o.maintainTypeStr = that.$t("desc.maintained");
            }
            if (o.pushType == 1) {
              o.maintainTypeStr = that.$t("desc.pushed");
            } else {
              o.maintainTypeStr = that.$t("desc.notPush");
            }
          });
          //导入数据里有null会导致文件损坏
          const dataSource = data.map((item) => {
            Object.keys(item).forEach((key) => {
              // 后端传null node写入会有问题
              if (item[key] === null) {
                item[key] = "";
              }

              if (Array.isArray(item[key])) {
                item[key] = item[key].join(",");
              }
            });
            return item;
          });
          dataSource.forEach((item) => {
            let rowData = [];
            rowData = [
              item.dsn,
              item.modelId,
              item.customerName,
              item.customerCenter,
              item.ccn,
              item.gsn,
              item.runningTime,
              item.maintainType,
              item.gatewayState,
              item.maintainTypeStr,
            ];
            exportData.push(rowData);
          });
          exportExcelNew(exportData, fileName);
          // exportExcel(headers, dataSource, fileName);
          that.loading = false;
        }
      });
    },
  },
};
</script>
 
<style scope>
.el-table__fixed-right {
  right: 0px !important;
}
.el-checkbox__label {
  padding-left: 5px;
}
.el-checkbox {
  margin-right: 20px;
}
.el-table thead.is-group th {
  line-height: 20px;
}
.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
  border-color: #000000;
}
</style>
